import { render, staticRenderFns } from "./Binari.vue?vue&type=template&id=289f3378&"
import script from "./Binari.vue?vue&type=script&lang=js&"
export * from "./Binari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports